module.exports = __webpack_public_path__ + "static/media/umunara_logo.97fd19dc.png";